import { Theme } from '@mui/material/styles'
import { TabProps } from '@mui/material/Tab'

import { onHover } from '../interaction'
import { PAGE_TABS_HEIGHT } from '../../app/pageHeaderSx'

// ----------------------------------------------------------------------

export default function Tabs(theme: Theme) {
  return {
    MuiTabs: {
      defaultProps: {
        textColor: 'inherit',
        allowScrollButtonsMobile: true,
        variant: 'scrollable',
      },
      styleOverrides: {
        root: { minHeight: PAGE_TABS_HEIGHT },
        scrollButtons: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        iconPosition: 'start',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: TabProps }) => ({
          padding: 0,
          opacity: 1,
          minWidth: 48,
          fontWeight: theme.typography.fontWeightMedium,
          // 24px at every width: 40px left a short tab bar reading as separate words rather than one
          // control, and the editors and sub-tabs had already narrowed it to this.
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(3),
          },
          // The global `disableRipple` in Focus.ts trades the ripple for designed
          // hover/active states, but Tab never got one — MUI ships no hover
          // background for it, so a tab bar was the one control cluster in the app
          // that answered the pointer with nothing at all. Ink rather than a wash:
          // a tab is a text target, and a box appearing behind it competes with the
          // selected tab's own indicator.
          '&:not(.Mui-selected)': {
            color: theme.palette.text.secondary,
            ...onHover({ color: theme.palette.text.primary }, { color: theme.palette.text.secondary }),
          },
          ...((ownerState.iconPosition === 'start' || ownerState.iconPosition === 'end') && {
            minHeight: PAGE_TABS_HEIGHT,
          }),
        }),
      },
    },
  }
}
